var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeaderSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 1.7372V0.97699M12.0003 23.0231V22.2629M22.2632 12H23.0234M0.977295 12H1.73751M19.2579 4.7432L19.7955 4.20566M4.20516 19.7945L4.74271 19.2569M19.2579 19.2569L19.7955 19.7944M4.20516 4.2056L4.74271 4.74315M18.0672 11.9585C18.0672 15.3173 15.3443 18.0401 11.9855 18.0401C8.62667 18.0401 5.90381 15.3173 5.90381 11.9585C5.90381 8.59964 8.62667 5.87678 11.9855 5.87678C15.3443 5.87678 18.0672 8.59964 18.0672 11.9585Z",
    stroke: "#42485A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderSun);
export default __webpack_public_path__ + "static/media/Icon-Header-Sun.a47ee33f6f7aa7f530af6a3ad7c31caa.svg";
export { ForwardRef as ReactComponent };